import {css} from '@yandex-delivery/blocks/theme/css'

export const additionalPaper = css`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding-block-end: 0;
`
